import React, { useState, useEffect } from 'react';
import { APIROOT } from '../../../Helpers/configs';

// import { convertDate } from '../../Helpers/helpers';

// import { r2_updateData } from '../../Helpers/r2_requests';

import TechItemHistory from '../../Tech/TechItemHistory';

import { expiryDate, defineTicketNumber } from '../../../Helpers/helpers';
import ViewUploads from '../../Upload/ViewUploads';

// import Upload from '../Upload/ViewUploads';

import UnauthorisedAccess from '../../CommonComponents/UnauthorisedAccess';

import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import { GetAuth } from '../../../Auth/AuthProvider';
import { CustomerConstants, getCabinetType } from '../../../Helpers/requests';

import BillingNoteRepair from '../../BillingNotes/BillingNoteRepair';
import BillingNoteUpliftment from '../../BillingNotes/BillingNoteUpliftment';

import {
  modalStyle600,
  modalStyle900,
  modalStyle1024,
} from '../../shared/commonStyle';

import {
  Box,
  Grid,
  Typography,
  Autocomplete,
  TextField,
  Switch,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Divider,
  Modal,
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  AddToPhotosOutlined as AddMoreIcon,
} from '@mui/icons-material';

import { ticketTypoTitle, ticketTypoInfo } from '../../shared/commonStyle';
// import { fontWeight } from '@mui/system';
// import Ticket from '../Ticket/Ticket';

function createData(id, date, description) {
  return { id, date, description };
}

const fakeHistoryRows = [
  createData('1', '12/03/2022', 'Replaced Compressor'),
  createData('2', '22/12/2021', 'Cleaned Condensors'),
];

//BUILD DATA
const RepairTicketCheckAndAuth = () => {
  const navigateNew = useNavigate();

  const [packetData, setPacketData] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(1);

  const location = useLocation();
  const ticketData = location.state;
  const [history, setHistory] = useState([]);
  const [fullSerialList, setFullSerialList] = useState([]);

  const [cabinetData, setCabinetData] = useState(ticketData.cabinetData);

  // const [serialNumber, setSerialNumber] = useState({
  //   id: cabinetData.serialId,
  //   name: cabinetData.serialNo,
  // });
  const [expiryDateVal, setExpiryDateVal] = useState('');

  const [open, setOpen] = useState(false);
  const handleOpen = () => checkBillingNote(ticketDataReq);
  const handleClose = () => {
    setOpen(false);
    setForceUpdate(forceUpdate + 1);
  };

  const [open3, setOpen3] = useState(false);
  const handleOpen3 = () => setOpen3(true);
  const handleClose3 = () => setOpen3(false);

  const checkBillingNote = (data) => {
    // const arr = data.jobcard;
    // arr.order_number
    setOpen(true);
  };

  const [categoriesData, setCategoriesData] = useState([]);
  const [regionsData, setRegionsData] = useState([]);

  const [useType, setUseType] = useState(localStorage.getItem('type'));

  const [ticketState, setTicketState] = useState({
    selectedCategory: null,
    selectedStoreName: null,
    notify: true,
    cabinetCount: 1,
  });

  // useEffect(() => {
  //   const serial = serialNumber;
  //   const data = fetchHistory(serial.id, setHistory);
  //   data === undefined ? setHistory([]) : setHistory(data);
  // }, [serialNumber]);

  const calculateWarrantee = (list, serial) => {
    const dateGroup = list.filter((cab) => {
      return cab.serial_number === serial.name;
    });
    let data =
      dateGroup[0] === undefined
        ? 'No Date Set'
        : expiryDate(dateGroup[0].install_date, dateGroup[0].warranty_period);

    setExpiryDateVal(data);
  };

  // useEffect(() => {
  //   const serial = serialNumber;
  //   const serials = fullSerialList;
  //   calculateWarrantee(serials, serial);
  // }, [fullSerialList, serialNumber]);

  // const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedStore, setSelectedStore] = useState(ticketData.store_name);

  const enqNotification = GetAuth().Notification;
  const logout = GetAuth().signOut;

  // const setCategory = (event, newValue) => {
  //   // setSelectedCategory(newValue);
  //   setTicketState({ ...ticketState, selectedCategory: newValue });
  // };

  // const setStore = (event, newValue) => {
  //   setSelectedStore(newValue);
  // };

  // const handleChange = (event) => {
  //   setTicketState({
  //     ...ticketState,
  //     notify: event.target.checked,
  //   });
  // };

  const createCabinet = () => {
    // setTicketState({ ...ticketState, cabinetCount: 1 });
    return useType === 'technician' ? (
      <UnauthorisedAccess />
    ) : (
      <Box>
        {ticketData.serial_numbers.map((cabinet) => (
          <Box key={cabinet.id}>
            <Grid
              container
              xs={12}
              md={12}
              flexDirection='row'
              rowGap={1}
              columnGap={0}
              alignContent='flex-start'
              paddingBottom={1}
            >
              <Grid
                container
                xs={12}
                md={6}
                flexDirection='row'
                rowGap={1}
                // // columnGap={1}
                alignContent='flex-start'
              >
                <Grid item xs={12} lg={3}>
                  <Typography style={ticketTypoTitle}>Cabinet Type:</Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={8}
                  style={{
                    background: '#none',
                    border: 'solid 2px #354775',
                    paddingLeft: '5px',
                  }}
                >
                  <Typography style={ticketTypoInfo}>
                    {cabinet.cabType}
                  </Typography>
                </Grid>
                <Grid item xs={12} lg={3}>
                  <Typography style={ticketTypoTitle}>
                    Serial Number:
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={8}
                  style={{
                    background: '#none',
                    border: 'solid 2px #354775',
                    paddingLeft: '5px',
                  }}
                >
                  <Typography style={ticketTypoInfo}>
                    {cabinet.serialNo}
                  </Typography>
                </Grid>
              </Grid>

              <Grid
                container
                xs={12}
                md={6}
                flexDirection='row'
                rowGap={1}
                // // columnGap={1}
                alignContent='flex-start'
              >
                <Grid item xs={12} lg={3}>
                  <Typography style={ticketTypoTitle}>
                    Warrantee Expiry:
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={8}
                  style={{
                    background: '#none',
                    border: 'solid 2px #354775',
                    paddingLeft: '5px',
                  }}
                >
                  {cabinet.exp}
                </Grid>
                <Grid item xs={12} lg={3}>
                  <Typography style={ticketTypoTitle}>Work Done:</Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={8}
                  style={{
                    background: '#none',
                    border: 'solid 2px #354775',
                    paddingLeft: '5px',
                  }}
                >
                  {cabinet.description}
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              xs={12}
              md={12}
              flexDirection='row'
              rowGap={1}
              columnGap={0}
              alignContent='flex-start'
              paddingBottom={1}
            >
              <Grid item xs={12} lg={1.5}>
                <Typography style={ticketTypoTitle}>History:</Typography>
              </Grid>

              <Grid
                item
                xs={12}
                lg={10}
                style={{
                  background: '#none',
                  border: 'solid 2px #354775',
                  // paddingLeft: '5px',
                }}
              >
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    background='#none'
                    aria-controls='panel1a-content'
                    id='panel1a-header'
                    style={{ background: '#none' }}
                  >
                    <Typography>Repair History</Typography>
                  </AccordionSummary>
                  <AccordionDetails style={{ background: '#none' }}>
                    <TechItemHistory serialId={cabinet.serialId} />
                  </AccordionDetails>
                </Accordion>
              </Grid>
            </Grid>
          </Box>
        ))}
      </Box>
    );
  };

  useEffect(() => {
    setTicketState({
      ...ticketState,
      selectedCategory: {
        id: '77EEFB76-B953-4143-BD8E-FCC9548F0D1F',
        name: 'Shoprite',
      },
    });
  }, []);

  useEffect(() => {
    CustomerConstants({
      resource: `/api/constants/customer`,
      setCategoriesFunc: setCategoriesData,
      setRegionsFunc: setRegionsData,
      setAsset_compFunc: () => {},
      setLoadingFunc: false,
      showNotification: enqNotification,
      logout,
    });
  }, [enqNotification, logout]);

  const [ticketDataReq, setTicketDataReq] = useState({});

  const [billingReady, setBillingReady] = useState('not ready');

  useEffect(() => {
    const count = forceUpdate;
    getTicketDatabyId(location.state.id).then((data) => {
      setTicketDataReq(data.data.value);
      setBillingReady(data.data.value['repair-ticket'].status);
      setPacketData(data.data.value.jobcard);
      // console.log(data.data.value);
    });
  }, [location.state, forceUpdate]);

  // console.log(packetData);
  const combineDataReSubmit = (action) => {
    let combineTicketBlob = {
      repair_ticket: {
        id: ticketData.id,
        status: action,
      },
    };
    return combineTicketBlob;
  };

  const combineDataComplete = (action) => {
    // console.log(ticketData.ticket_type);
    let completeTicketBlob = {
      repair_ticket: {
        id: ticketData.id,
        ticket_type: ticketData.ticket_type,
        status: action,
      },
    };

    return completeTicketBlob;
  };

  const checkAction = (action) => {
    const blobType =
      action === 'completed'
        ? combineDataComplete(action)
        : combineDataReSubmit(action);
    return blobType;
  };

  const ticketUpdate = (ticketId, actionType) => {
    const DataBlob = { ...checkAction(actionType) };
    // console.log(DataBlob);
    //Get JWT from storage
    let JWT = localStorage.getItem('JWT_Key');
    //Set default Headers
    let headers = {
      'content-type': 'application/JSON',
    };
    //Set JWT in header if available
    if (JWT) {
      headers['x-api-key'] = JWT;
    }
    let body = {};
    body = DataBlob;
    const request = new Request(
      `${APIROOT}/api/r2_repair_tickets/${ticketId}`,
      {
        method: 'post',
        headers,
        body: JSON.stringify(body),
      }
    );
    fetch(request)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error(`Failed to save ticket`);
        }
      })
      .then((data) => {
        let parsed = JSON.parse(data);
        if (parsed.success === true) {
          setForceUpdate((val) => val + 1);
          //Update JWT if required
          if (parsed.JWT) {
            localStorage.setItem('JWT_Key', parsed.JWT);
          }
          enqNotification(`Ticket Updated to ${actionType}`, 'success');
          //CLOSE HERE
        } else {
          //Force logout
          if (parsed.message === 'Please login') {
            logout(() => {
              enqNotification('Session Expired', 'warning');
            });
          } else {
            enqNotification(parsed.message, 'error');
          }
        }
      })
      .catch((error) => {
        enqNotification(
          typeof error == 'string' ? error : `Connection Error !! ${error}`,
          'error'
        );
      });
  };

  return (
    <Box
      style={{
        minHeight: '20vh',
        maxWidth: '100vw',
        textAlign: 'left',
        border: 'solid 2px #354775',
        background: '#ebedf8',
        borderRadius: '5px',
      }}
    >
      <Typography
        style={{
          background: '#354775',
          padding: '15px',
          border: 'solid 2px #354775',
          color: '#ffffff',
        }}
        variant='h5'
      >
        TICKET NR:{' '}
        {defineTicketNumber(ticketData.ticket_type, ticketData.id, '5', 'R')}
      </Typography>
      <Box
        name='customerDetails'
        style={{
          minHeight: '20vh',
          // maxWidth: '100%',
          textAlign: 'left',
          background: '#ebedf8',
          borderRadius: '5px',
          padding: '15px',
        }}
      >
        <Grid
          container
          // justifyContent='space-between'
          // alignItems='center'
          flexDirection={{ xs: 'column', sm: 'row' }}
          sx={{ fontSize: '12px' }}
          xs={12}
          md={12}
          lg={12}
          spacing={0}
          rowGap={1}
          // columnGap={1}
        >
          <Grid
            container
            // justifyContent='space-between'
            // alignItems='center'
            flexDirection={{ xs: 'column', sm: 'row' }}
            sx={{ fontSize: '12px' }}
            xs={12}
            md={12}
            lg={12}
          >
            <Grid item xs={12} lg={1.5}>
              <Typography style={ticketTypoTitle}>Category:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={4}
            >
              <Typography style={ticketTypoInfo}>
                {ticketData.customer_category_name}
              </Typography>
            </Grid>
            <Grid item xs={0} lg={0.5}></Grid>
            <Grid item xs={12} lg={1.5}>
              <Typography style={ticketTypoTitle}>Store Name:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={4}
            >
              <Typography style={ticketTypoInfo}>
                {ticketData.customer_name}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            flexDirection={{ xs: 'column', sm: 'row' }}
            sx={{ fontSize: '12px' }}
            xs={12}
            md={6}
            lg={6}
            // spacing={0}
            rowGap={1}
          >
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Address:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={8}
            >
              <Typography style={ticketTypoInfo}>
                {ticketData.customer_address}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Contact Person:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={8}
            >
              <Typography style={ticketTypoInfo}>
                {ticketData.customer_contact_name}
              </Typography>
            </Grid>

            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Contact Number:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={8}
            >
              <Typography style={ticketTypoInfo}>
                {ticketData.customer_contact_number}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            flexDirection={{ xs: 'column', sm: 'row' }}
            sx={{ fontSize: '12px' }}
            xs={12}
            md={6}
            lg={6}
            // spacing={0}
            rowGap={1}
          >
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Branch Code:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={8}
            >
              <Typography style={ticketTypoInfo}>
                {ticketData.customer_branchcode}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>WI Nr:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={8}
            >
              <Typography style={ticketTypoInfo}>
                {ticketData.wi_number}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Asset Comp:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={8}
            >
              <Typography style={ticketTypoInfo}>
                {ticketData.customer_asset_comp_name}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Store Order Nr.:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={8}
            >
              <Typography style={ticketTypoInfo}>
                {packetData.order_number}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>GRN nr.:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={8}
            >
              <Typography style={ticketTypoInfo}>
                {packetData.grn_number}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={3}>
              <Typography style={ticketTypoTitle}>Tech:</Typography>
            </Grid>
            <Grid
              style={{
                background: '#none',
                border: 'solid 2px #354775',
                paddingLeft: '5px',
              }}
              item
              xs={12}
              lg={8}
            >
              <Typography style={ticketTypoInfo}>
                {ticketData.tech_assigned_name}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{ marginTop: '10px' }}
          xs={12}
          md={12}
          flexDirection='row'
          rowGap={1}
          columnGap={0}
          alignContent='flex-start'
        >
          <Grid item xs={12} lg={1.5}>
            <Typography style={ticketTypoTitle}>Description:</Typography>
          </Grid>

          <Grid
            item
            xs={12}
            lg={10}
            style={{
              background: '#none',
              border: 'solid 2px #354775',
              paddingLeft: '5px',
            }}
          >
            <Typography style={ticketTypoInfo}>
              {ticketData.description}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Divider />

      <Box
        style={{
          // minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          borderRadius: '5px',
          padding: '0 15px 15px 15px',
        }}
      >
        <Typography variant='h6'>Logged Cabinets:</Typography>
        {createCabinet()}
      </Box>
      <Divider style={{ marginBottom: '15px' }} />

      <Box
        name='ticketDetails'
        style={{
          // minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          borderRadius: '5px',
          padding: '0 15px 15px 15px',
        }}
      >
        <Grid
          container
          xs={12}
          md={12}
          flexDirection='row'
          rowGap={1}
          // columnGap={1}
          alignContent='flex-start'
        >
          <Grid item xs={12} lg={1.5}>
            <Typography style={ticketTypoTitle}>
              Customer Notes on Job Card:
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            lg={10}
            style={{
              background: '#none',
              border: 'solid 2px #354775',
              paddingLeft: '5px',
            }}
          >
            <Typography style={ticketTypoInfo}>{packetData.notes}</Typography>
          </Grid>
        </Grid>
      </Box>

      <Divider />
      <Box
        name='ticketActions'
        style={{
          // minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'right',
          borderRadius: '5px',
          padding: '0 15px 15px 15px',
          margin: '10 0',
        }}
      >
        <Grid
          container
          // justifyContent='space-between'
          // alignItems='center'
          flexDirection={{ xs: 'column', sm: 'row' }}
          sx={{ fontSize: '12px' }}
          xs={12}
          md={12}
          lg={12}
          spacing={0}
          rowGap={1}
        >
          <Grid
            container
            // justifyContent='space-between'
            // alignItems='center'
            flexDirection={{ xs: 'column', sm: 'row' }}
            sx={{ fontSize: '12px' }}
            xs={12}
            md={12}
            lg={12}
          >
            <Grid item xs={12} lg={2}></Grid>
            <Grid item xs={12} lg={2} paddingLeft='5px'>
              <Button
                sx={{ minWidth: '120px' }}
                fullWidth
                variant='contained'
                color='btn_info'
                style={{
                  marginTop: '5px ',
                  fontWeight: '700',
                }}
                onClick={() => {
                  handleOpen3();
                }}
              >
                View Docs
              </Button>
            </Grid>
            <Grid item xs={12} lg={2} paddingLeft='5px'>
              <Button
                sx={{ minWidth: '120px' }}
                fullWidth
                onClick={() => {
                  handleOpen();
                }}
                variant='contained'
                color='btn_info'
                style={{
                  marginTop: '5px',
                  fontWeight: '700',
                }}
                // disabled={
                //   billingReady === 'logged' ||
                //   billingReady === 'assigned' ||
                //   billingReady === 'open'
                //     ? true
                //     : false
                // } //pending
              >
                Billing Note
              </Button>
            </Grid>
            <Grid item xs={12} lg={2} paddingLeft='5px'>
              <Button
                sx={{ minWidth: '120px' }}
                disabled={
                  billingReady === 'upliftment'
                    ? false
                    : ticketData.sub_assigned !== null &&
                      billingReady === 'assigned'
                    ? false
                    : billingReady !== 'pending auth'
                    ? true
                    : false

                  // ticketData.sub_assigned !== null
                  //   ? false
                  //   : billingReady !== 'pending auth'
                  //   ? true
                  //   : false

                  // ||
                  // billingReady !== 'pending auth'

                  // billingReady === 'query'
                  //   ? false
                  //   : billingReady === 'pending auth'
                  //   ? false
                  //   : true
                } //pending
                fullWidth
                variant='contained'
                color='success'
                style={{ marginTop: '5px', fontWeight: '700' }}
                onClick={() => ticketUpdate(ticketData.id, 'completed')}
              >
                Complete
              </Button>
              <Button
                sx={{ minWidth: '120px' }}
                fullWidth
                onClick={() => ticketUpdate(ticketData.id, 'ready to approve')}
                variant='contained'
                color='success'
                style={{
                  marginTop: '5px',
                  fontWeight: '700',
                }}
                disabled={
                  billingReady === 'query'
                    ? false
                    : billingReady === 'declined'
                    ? false
                    : billingReady !== 'completed'
                    ? true
                    : false
                } //pending
                // disabled={billingReady !== 'completed' ? true : false} //pending
              >
                Ready to Approve
              </Button>
              <Button
                sx={{ minWidth: '120px' }}
                fullWidth
                onClick={() => ticketUpdate(ticketData.id, 'ready to invoice')}
                variant='contained'
                color='success'
                style={{ marginTop: '5px', fontWeight: '700' }}
                disabled={billingReady !== 'ready to approve' ? true : false} //pending
              >
                Ready To Invoice
              </Button>
            </Grid>
            <Grid item xs={12} lg={2} paddingLeft='5px'>
              <Button
                sx={{ minWidth: '120px' }}
                fullWidth
                onClick={() => ticketUpdate(ticketData.id, 're-submit')}
                variant='contained'
                color='warning'
                style={{ marginTop: '5px', fontWeight: '700' }}
                disabled={billingReady === 'pending auth' ? false : true}
              >
                Re-Submit
              </Button>
              <Button
                sx={{ minWidth: '120px', height: '37px' }}
                fullWidth
                // variant='contained'
                style={{ marginTop: '5px', fontWeight: '700' }}
                disabled={true}
              >
                {/* ghost button */}
              </Button>
              <Button
                sx={{ minWidth: '120px' }}
                fullWidth
                variant='contained'
                color='error'
                style={{ marginTop: '5px', fontWeight: '700' }}
                onClick={() => ticketUpdate(ticketData.id, 'declined')}
                disabled={billingReady === 'ready to approve' ? false : true} //pending
              >
                Decline
              </Button>
            </Grid>
            <Grid item xs={12} lg={2} paddingLeft='5px'>
              <Button
                sx={{ minWidth: '120px' }}
                fullWidth
                variant='contained'
                color='primary'
                style={{ marginTop: '5px', fontWeight: '700' }}
                onClick={() =>
                  navigateNew(`/ticket`, {
                    replace: true,
                  })
                }
              >
                Back
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          // justifyContent='space-between'
          // alignItems='center'
          flexDirection={{ xs: 'column', sm: 'row' }}
          sx={{ fontSize: '12px' }}
          xs={12}
          md={12}
          lg={12}
          spacing={0}
          rowGap={1}
        >
          <Grid
            container
            // justifyContent='space-between'
            // alignItems='center'
            flexDirection={{ xs: 'column', sm: 'row' }}
            sx={{ fontSize: '12px' }}
            xs={12}
            md={12}
            lg={12}
          >
            <Grid item xs={12} lg={6}></Grid>

            <Grid item xs={12} lg={2} paddingLeft='5px'>
              <Button
                sx={{ minWidth: '120px' }}
                disabled={billingReady === 'ready to invoice' ? false : true} //pending
                fullWidth
                variant='contained'
                color='success'
                style={{ marginTop: '5px', fontWeight: '700' }}
                onClick={() => ticketUpdate(ticketData.id, 'invoiced')}
              >
                Invoiced
              </Button>
              <Button
                sx={{ minWidth: '120px' }}
                fullWidth
                onClick={() => ticketUpdate(ticketData.id, 'submitted')}
                variant='contained'
                color='success'
                style={{
                  marginTop: '5px',
                  fontWeight: '700',
                }}
                disabled={billingReady !== 'invoiced' ? true : false} //pending
              >
                submitted
              </Button>
              <Button
                sx={{ minWidth: '120px' }}
                fullWidth
                onClick={() => ticketUpdate(ticketData.id, 'closed')}
                variant='contained'
                color='success'
                style={{ marginTop: '5px', fontWeight: '700' }}
                disabled={billingReady !== 'submitted' ? true : false} //pending
              >
                Closed
              </Button>
            </Grid>
            <Grid item xs={12} lg={2} paddingLeft='5px'>
              <Button
                disabled={
                  billingReady === 'upliftment'
                    ? true
                    : billingReady === 'query'
                    ? true
                    : billingReady === 'assigned'
                    ? true
                    : billingReady === 'stop'
                    ? true
                    : billingReady === 'logged'
                    ? true
                    : billingReady === 'declined'
                    ? true
                    : billingReady === 'pending auth'
                    ? true
                    : billingReady === 'completed'
                    ? true
                    : billingReady === 're-submit'
                    ? true
                    : false
                }
                sx={{ minWidth: '120px' }}
                fullWidth
                onClick={() => ticketUpdate(ticketData.id, 'query')}
                variant='contained'
                color='warning'
                style={{ marginTop: '5px', fontWeight: '700' }}
              >
                Query
              </Button>
            </Grid>
            <Grid item xs={12} lg={2} paddingLeft='5px'></Grid>
          </Grid>
        </Grid>

        <Grid
          container
          xs={12}
          md={12}
          flexDirection='row'
          rowGap={1}
          columnGap={1}
          alignContent='flex-start'
        ></Grid>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={modalStyle600} md={modalStyle900} lg={modalStyle1024}>
          {ticketData.ticket_type === 'upliftment' ? (
            <BillingNoteUpliftment
              ticketData={ticketDataReq}
              // modalData={modalData}
              closeModel={handleClose}
              // modalMode={editOrSave}
              readyToApprove={() => {
                ticketUpdate(ticketData.id, 'ready to approve');
                handleClose();
              }}
              readyToInvoice={() => {
                ticketUpdate(ticketData.id, 'ready to invoice');
                handleClose();
              }}
            />
          ) : (
            <BillingNoteRepair
              relationId={ticketData.id}
              ticketData={ticketDataReq}
              // modalData={modalData}
              closeModel={handleClose}
              // modalMode={editOrSave}
            />
          )}
        </Box>
      </Modal>
      <Modal
        open={open3}
        onClose={handleClose3}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={uploadModalStyle}>
          <ViewUploads
            relationId={ticketData.id}
            relationType='repairTickets'
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default RepairTicketCheckAndAuth;

function fetchHistory(serialID, setDataFunc) {
  //Get JWT from storage
  let JWT = localStorage.getItem('JWT_Key');

  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  const request = new Request(
    `${APIROOT}/api/serialnumberhistory/${serialID}`,
    { method: 'POST', headers: headers }
  );

  fetch(request)
    .then((data) => {
      if (data.status === 200) {
        return data.text();
      } else {
        throw new Error(`Invalid Response`);
      }
    })
    .then((data) => {
      var parsed = JSON.parse(data);
      if (parsed.success === true) {
        setDataFunc(parsed.data.value);
        if (parsed.JWT) {
          localStorage.setItem('JWT_Key', parsed.JWT);
        }
      }
    })
    .catch((error) => {
      console.log(error);
    });
}

//TICKET DATA
async function getTicketDatabyId(TicketId) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {};

  const request = new Request(`${APIROOT}/api/repair-tickets/${TicketId}`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}

const uploadModalStyle = {
  position: 'absolute',

  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  height: '80vh',
  overflow: 'scroll',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
